import React from 'react';
import Testimonials from '@anonymizePro/components/testimonials-pricing/testimonials';
import Pricing from '@anonymizePro/components/testimonials-pricing/pricing';

function Index() {
    return (
        <div className="mb-[200px] flex w-full bg-gradient-to-t from-blue-200 to-red-200 lg:mb-[301px] ">
            <div className="flex w-full flex-col items-center bg-white md:rounded-t-[72px] ">
                <Testimonials />
                <Pricing />
            </div>
        </div>
    );
}

export default Index;
